import { apiRequest } from './client';
import type {
  AttentionItem,
  Pagination,
  QuestionAnalytics,
  ReviewResult,
  ReviewStatus,
  SupervisionFilters,
  SupervisionStoreRow,
  SupervisionSummary,
  SupervisionTemplateRow,
  TemplateQuestionOption,
  TextItem,
  TrendBucket,
  TrendPoint,
} from '../types/formSupervision';

// Fase 23C: cliente HTTP del panel de supervision (SOLO LECTURA + acuse de revision). El backend valida
// y es autoritativo; nunca se envia businessId (sesion).
const PATH = '/api/form-supervision';

function toQuery(filters: Record<string, string | number | boolean | undefined>) {
  const query = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => { if (v !== undefined && v !== '') query.set(k, String(v)); });
  // Sin `URLSearchParams.size`: no existe en Chromium 83, el WebView de Android 11 (Bloque G).
  const search = query.toString();
  return search ? `?${search}` : '';
}

export const getSupervisionSummary = (f: SupervisionFilters) =>
  apiRequest<SupervisionSummary>(`${PATH}/summary${toQuery({ ...f })}`);

export const getSupervisionStores = (f: SupervisionFilters) =>
  apiRequest<{ stores: SupervisionStoreRow[] }>(`${PATH}/stores${toQuery({ ...f })}`);

export const getSupervisionTemplates = (f: SupervisionFilters) =>
  apiRequest<{ templates: SupervisionTemplateRow[] }>(`${PATH}/templates${toQuery({ ...f })}`);

export const getAttentionInbox = (f: SupervisionFilters, opts: { reviewStatus?: ReviewStatus; limit?: number; offset?: number } = {}) =>
  apiRequest<{ items: AttentionItem[]; pagination: Pagination }>(`${PATH}/attention${toQuery({ ...f, ...opts })}`);

export const getTextResponses = (f: SupervisionFilters, opts: { logicalKey?: string; limit?: number; offset?: number } = {}) =>
  apiRequest<{ items: TextItem[]; pagination: Pagination }>(`${PATH}/text-responses${toQuery({ ...f, ...opts })}`);

export const getSupervisionTrends = (f: SupervisionFilters, opts: { bucket?: TrendBucket; logicalKey?: string } = {}) =>
  apiRequest<{ bucket: TrendBucket; points: TrendPoint[] }>(`${PATH}/trends${toQuery({ ...f, ...opts })}`);

// Preguntas logicas observadas de una plantilla (para el selector de analitica). templateId requerido.
export const getTemplateQuestions = (f: SupervisionFilters & { templateId: string }) =>
  apiRequest<{ questions: TemplateQuestionOption[] }>(`${PATH}/template-questions${toQuery({ ...f })}`);

// La analitica por pregunta exige templateId (contrato backend).
export const getQuestionAnalytics = (logicalKey: string, f: SupervisionFilters & { templateId: string }) =>
  apiRequest<QuestionAnalytics>(`${PATH}/questions/${logicalKey}${toQuery({ ...f })}`);

export const reviewAttention = (submissionId: string, questionId: string) =>
  apiRequest<ReviewResult>(`${PATH}/attention/${submissionId}/${questionId}/review`, { method: 'POST', body: JSON.stringify({}) });
